import {Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {Router} from '@angular/router';
import {AnalyticsService} from '../../shared/analytics.service';
import {AppStateService} from '../../shared/app-state.service';
import {AuthService} from '../../shared/auth.service';
import {PositionStatus} from '../position-search.pipe';
import {QccModalComponent} from '../qcc-modal/qcc-modal.component';
import {TrackerActivityPipe} from '../tracker-activity.pipe';
import {COLORS, VT_TALENT_COLOR} from '../../shared/avatar/avatar.component';
import {map} from 'rxjs/operators';
import {environment} from '../../../environments/environment';

@Component({
  selector: 'position-summary-decoy',
  templateUrl: './position-summary-decoy.component.html',
  styleUrls: [
    '../styles/position-summary.scss',
    '../position-summary/position-summary.component.scss',
    '../position-activity/position-activity.component.scss',
    './position-summary-decoy.component.scss'
  ]
})
export class PositionSummaryDecoyComponent {

  @Input() order: Order;
  @Input() staff: StaffInfo[];
  @Input() colorIndex: number;

  @Output() reload = new EventEmitter<void>();

  @ViewChild('qccModal') qccModal: QccModalComponent;

  endOfAssignment = environment.flags.endOfAssignment;

  status: PositionStatus;
  activityType: string;
  brand$ = this.AppState.brand$;
  masquerading$ = this.Auth.masquerading$;
  user$ = this.Auth.user$;
  backgroundColor$ = COLORS[this.colorIndex % COLORS.length].backgroundColor;

  constructor(private Router: Router,
              private Analytics: AnalyticsService,
              private ActivityPipe: TrackerActivityPipe,
              private Auth: AuthService,
              private AppState: AppStateService) {
  }

}
